<template>
 <router-view></router-view>

</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
